var option = 'fx_2d2fb1e5_oqbb3n0';
var optionClickable = 'fx_2d2fb1e5_oqbb3n1';
var optionContent = 'fx_2d2fb1e5_oqbb3n2';
var optionDescription = 'fx_2d2fb1e5_oqbb3n5';
var optionTitle = 'fx_2d2fb1e5_oqbb3n3';
var optionTitleText = 'fx_2d2fb1e5_oqbb3n4';

export { option, optionClickable, optionContent, optionDescription, optionTitle, optionTitleText };
//# sourceMappingURL=option.vanilla.mjs.map
